
/*
 * Copyright (c) 2022 by Leyton Group - All Rights Reserved.
 * This source code, and resulting software, is the confidential and proprietary information
 * ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 * of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 * and shall use it only in accordance with the terms and conditions of any and all license
 * agreements you have entered into with The Company.
 */

import {roleService} from "@/views/service/role.service";

const state = {
    roles: []
};

const getters = {
    getRoles: state => state.roles
}

const mutations = {
    rolesMutation: (state, roles) => state.roles = roles
}

const actions = {
    fetchRolesAction({commit}, {pagedFilter}) {
        roleService.fetchRoles(pagedFilter)
            .then(roles =>
                commit('rolesMutation', roles)
            );
    }
}

export const role = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
